import "../../scss/shortcodes/polls.scss";
import { fireSelects } from "../components/select";
import ReplaceContent from "../components/ReplaceContent";

document.addEventListener("DOMContentLoaded", function(event) {
    fireSelects();
    new ReplaceContent();

    let headers = {
        "Content-Type": "text/html",
        "X-Requested-With": "XMLHttpRequest"
    };
    const token = localStorage.getItem('token') ?? '';
    if (token) {
        headers = {
            "Content-Type": "text/html",
            "X-Requested-With": "XMLHttpRequest",
            "Authorization": `Bearer ${token}`
        };
    }

    let activePolls = document.querySelectorAll(".active-poll-container");
    activePolls.forEach((activePoll) => {
        let ajaxUrl = activePoll.dataset.get;
        fetch(ajaxUrl, {
            method: "GET",
            headers: headers,
        })
        .then(
            response => response.text()
        )
        .then(html => {
            activePoll.innerHTML = html;
        })
        .catch(function (error) {
            console.log(error);
        });
    });

    /*let containerOlderPolls = document.getElementById("pollCategoryFeed");
    if (containerOlderPolls){
        let ajaxUrl = containerOlderPolls.dataset.get;
        fetch(ajaxUrl, {
            method: "GET",
            headers: headers,
        })
            .then(
                response => response.text()
            )
            .then(html => {
                containerOlderPolls.innerHTML = html;
            })
            .catch(function (error) {
                console.log(error);
        });
    }*/

});

